import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Page } from "../util/page";
import { InventoryMovement } from "./model/inventory-movement";
import { ProductSynchronization } from "./model/product-synchronization";

@Injectable()
export class ShopifyService {
  constructor(private httpClient: HttpClient) { }

  public findInventoryMovementsByStatusIn(statuses: string[], page: number, sort: string): Observable<Page<InventoryMovement>> {
    var statusesParam = "";
    for (let status of statuses) {
      statusesParam += `status=${status}&`;
    }

    return this.httpClient.get<Page<InventoryMovement>>(`/api/shopify/inventory-movement?${statusesParam}page=${page}&sort=${sort}`);
  }

  public findLastSynchronization(): Observable<Date> {
    return this.httpClient.get<Date>(`/api/shopify/last-synchronization`);
  }

  public findProductSynchronizationsByStatusIn(statuses: string[], page: number, sort: string): Observable<Page<ProductSynchronization>> {
    var statusesParam = "";
    for (let status of statuses) {
      statusesParam += `status=${status}&`;
    }

    return this.httpClient.get<Page<ProductSynchronization>>(`/api/shopify/product-synchronization?${statusesParam}page=${page}&sort=${sort}`);
  }

  public retryErrors(): Observable<HttpResponse<void>> {
    return this.httpClient.post<HttpResponse<void>>(`/api/shopify?retryErrors`, {});
  }
}